<template>
  <ConfirmHour></ConfirmHour>
</template>

<script>
// @ is an alias to /src
import ConfirmHour from "@/components/ConfirmHour.vue";
export default {
  name: "ConfirmHourView",
  components: { ConfirmHour }
};
</script>
